import React from "react";
import PropTypes from 'prop-types';

export default class Education extends React.PureComponent {
    static propTypes = {
        education: PropTypes.string,
        language: PropTypes.string,
    };

    render() {
        return this.props.education
	        ? (
                <li>
	                <span>{window.Translator.getSlug('MinEducation', this.props.language)}:</span>{this.props.education}
                </li>
            ) : null;
    }
}
